import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useMemo } from "react";
import BoardThumbnail from "~/components/BoardThumbnail/BoardThumbnail";
import { getPreferenceImgixFit, useThumbnailPreference } from "~/hooks/useThumbnailPreference";
export const GalleryBoardThumbnail = /*#__PURE__*/ memo((param)=>{
    let { board, sizes } = param;
    const { getPreference } = useThumbnailPreference();
    const thumbnailPreference = useMemo(()=>getPreference(board.id), [
        board.id,
        getPreference
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "pointer-events-none absolute inset-1 overflow-hidden rounded-8",
        children: /*#__PURE__*/ _jsx(BoardThumbnail, {
            board: board,
            height: "100%",
            imgixParams: {
                fit: getPreferenceImgixFit(thumbnailPreference)
            },
            objectFit: thumbnailPreference === "default" ? "cover" : "contain",
            sizes: sizes,
            width: "100%"
        })
    });
});
GalleryBoardThumbnail.displayName = "GalleryBoardThumbnail";
